// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__WG3X7","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__kIXOa"};